export default __webpack_public_path__ + "static/media/S-044.44a6213e.png";